import React, { useState, useEffect } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import Menu from './Menu'
import { FooterSection } from './Footer'

function ProjectDetail({ data }) {
    // get dataect value from children
    const [name, setName] = useState(null)
    const [link, setLink] = useState(null)
    const [desc, setDesc] = useState(null)
    const [details, setDetails] = useState(null)

    // safe to session storage
    const getData = () => {
        const projectData = JSON.parse(localStorage.getItem('projectData'))
        if (!name && !link && !desc && !details) {
            const arr = []
            // arr.push(...projectData.detail)
            for (const data in projectData.details) {
                let obj = {
                    name: data,
                    data: projectData.details[data]
                }
                arr.push(obj)
            }
            setName(projectData.name)
            setLink(projectData.link)
            setDesc(projectData.desc)
            setDetails(arr)
        }
    }
    useEffect(() => {
        getData()
    }, [data])

    return (
        <>
            <Menu />
            <AnimatePresence>
                <motion.div className="project-detail-wrapper"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.8, type: "tween" }}
                >
                    <div className="project-detail-page">
                        {/* about page big title */}
                        <nav className="project-name-title">
                            <h1>{name}</h1>
                        </nav>
                        <div className="project-image">
                            <img src="" alt="" />
                        </div>
                        {/* description container */}
                        <section className="project-description">
                            <div className="project-desc-header">
                                <div className="title">
                                    {/* project name */}
                                    {/* {data.name} */}
                                    {name}
                                </div>
                                <div className="divider">
                                    <hr />
                                </div>
                            </div>
                            {/* description main content */}
                            {details && details.map((obj, i) => {
                                return (
                                    <div className="project-desc">
                                        <div className="desc-title">
                                            {obj.name}
                                        </div>
                                        <div className="desc-paragraph">
                                            <motion.p
                                                initial={{ opacity: 0, y: 20 }}
                                                animate={{ opacity: 1, y: 0 }}
                                                transition={{ type: "tween", ease: 'easeOut' }}
                                            >
                                                {obj.data}
                                            </motion.p>
                                        </div>
                                    </div>
                                )
                            })}
                        </section>
                        <FooterSection />
                    </div>
                </motion.div>
            </AnimatePresence >
        </>
    )
}

export default ProjectDetail